<div class="d-flex flex-column align-items-center">
    <i style="color: rgb(214, 214, 214)"  class="fa-solid fa-file fa-8x"></i>     
    <span class="mt-2 fw-lighter fs-6">Nada encontrado...</span>
</div>

